<div class="jumbotron">
    <h1 class="text-center">Offers Report</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                <div class="p-3">
                    <div
                        cmpsTdOffersSelectionReport
                        [params]="selectedParams"
                        [superGroups]="superGroups"
                        [reportPopulations]="reportPopulations"
                        (generated)="onGeneratedReport($event)"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Offers
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="selectedParams.pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>
                <div
                    class="p-3"
                    *ngIf="!selectedParams.pendingData && selectedParams.noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>
                <div
                    class="p-3"
                    *ngIf="
                        !selectedParams.pendingData && !selectedParams.noData
                    "
                >
                    <div>
                        <button
                            class="btn-mini"
                            [ngbTooltip]="buttonsTooltip"
                            (mouseover)="getTooltip('Refresh')"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            (click)="onExportClick()"
                            class="btn-mini"
                            (mouseover)="getTooltip('Export')"
                            [ngbTooltip]="buttonsTooltip"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>

                    Report Population:
                    <b class="f-s-75-2">{{ selectedPopulationType }}</b>
                    <span class="soft-pipe">|</span>
                    Selected:
                    <b class="f-s-75-2">{{
                        selectedParams.populationID
                            ? selectedParams.populationID.userName
                            : ''
                    }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Start Date:
                    <b class="f-s-75-2">{{
                        selectedStartDate | cmpsDate: 'yyyy-MM-dd'
                    }}</b>
                    <span class="soft-pipe">|</span>
                    Selected End Date:
                    <b class="f-s-75-2">{{
                        selectedEndDate | cmpsDate: 'yyyy-MM-dd'
                    }}</b>
                    <span class="soft-pipe">|</span>
                    Generated On:
                    <b class="f-s-75-2">{{
                        generatedDate | cmpsDate: 'yyyy-MM-dd HH:mm:ss'
                    }}</b>

                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th
                                    (click)="sortTable(0)"
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>Product</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(1)"
                                    class="title even"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>Total Offers</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(2)"
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>Yes</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(3)"
                                    class="title even"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>No</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(4)"
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>Maybe</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(5)"
                                    class="title even"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>% Offer Action Rate</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                                <th
                                    (click)="sortTable(3)"
                                    class="title odd"
                                    [style.min-width]="'100px'"
                                >
                                    <div class="tableHeader">
                                        <span>% Conversion</span>
                                        <cmps-icon
                                            svgIcon="chevron-down"
                                        ></cmps-icon>
                                    </div>
                                </th>
                            </tr>
                            <tr *ngFor="let row of data">
                                <td class="text-center vertical-center">
                                    {{ row.product }}
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.totalOffer }}
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.totalYes }}
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.totalNo }}
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.totalMaybe }}
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.offerActionRate }} %
                                </td>
                                <td class="text-center vertical-center">
                                    {{ row.conversion }} %
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>

<ng-template #buttonsTooltip>
    <div class="custom-tooltip no-min-width oatooltip">{{ tooltipText }}</div>
</ng-template>
